module.exports = __webpack_public_path__ + "static/fonts/iconfont.6ab6bdd5.ttf";